/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Waitlist_TitleInputs */

const en_waitlist_title = /** @type {(inputs: Waitlist_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waitlist`)
};

const es_waitlist_title = /** @type {(inputs: Waitlist_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lista de espera`)
};

/**
* | output |
* | --- |
* | "Waitlist" |
*
* @param {Waitlist_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const waitlist_title = /** @type {((inputs?: Waitlist_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Waitlist_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_waitlist_title(inputs)
	return es_waitlist_title(inputs)
});